import logger from '../../services/logging/logging-service';
import {
  createInsDataNode,
  getAdvData,
  initInjectedAdv,
  manipulateBanner,
  setAdvInsertedState,
  setAdvRemovedState,
} from '../../utils/adv-helper';

/**
 * ON MOBILE --> at the time of injection it shows the sticky banner above the card navigation.
 * ON DESKTOP --> at the time of injection it shows the FULLPAGE format
 * @param {*} $advStickyDataNode
 */
export const injectAdvSticky = ($advStickyDataNode) => {
  logger.info('[ADV STICKY] init adv-sticky');
  const { reviveId, zoneId } = getAdvData($advStickyDataNode);
  const $insDataNode = createInsDataNode(reviveId, zoneId);

  const $advStickyContainer = document.querySelector('#advStickyContainer');
  $advStickyContainer.appendChild($insDataNode);
  initInjectedAdv(reviveId);
  setAdvInsertedState($advStickyDataNode);
};

export const removeAdvSticky = ($advStickyDataNode) => {
  const { zoneId } = getAdvData($advStickyDataNode);
  manipulateBanner({ zoneId, action: 'destroy' });
  setAdvRemovedState($advStickyDataNode);
};

/**
 * ON MOBILE --> it refreshes the adv sticky on bottom (when fullscreen is true it shows the out-of-page format)
 * ON DESKTOP --> it only refreshes the out-of-page format (the sticky on bottom is not shown), so it has to be invoked with fullscreen: true
 * @param {*} $advStickyDataNode
 * @param {*} fullscreen
 */
export const refreshAdvSticky = ($advStickyDataNode, fullscreen) => {
  const { zoneId } = getAdvData($advStickyDataNode);
  manipulateBanner({ zoneId, action: 'refresh', fullscreen });
};
